import { Component, inject, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Verification } from '../../../services/verification';
import { NavStateService } from '../../../services/nav-state.service';
import { User } from '../../../services/user';
import { ViewUploadedFile } from '../../common-features/view-uploaded-file/view-uploaded-file';

@Component({
  selector: 'app-verification-history-details',
  standalone: false,
  templateUrl: './verification-history-details.html',
  styleUrl: './verification-history-details.less',
})
export class VerificationHistoryDetails implements OnInit {
  requestId: any;
  private verificationService = inject(Verification);
  private userService = inject(User);
  private navState = inject(NavStateService);
  private matDialog = inject(MatDialog);
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private location = inject(Location);
  verificationForm!: FormGroup;
  uploadedFiles: any[] = [];
  payload: any;

  constructor() {}

  ngOnInit(): void {
    this.navState.setCurrentTitle('Verification Details');
    this.navState.setShowBackButton(true);
    this.initForm();
    const inputData = window.history.state;
    this.requestId = inputData.id;
    if (this.requestId) {
      this.getVerificationDetailsById(this.requestId);
    }
  }

  getVerificationDetailsById(requestId: any) {
    this.verificationService.getVerificationHistoryById(requestId).subscribe({
      next: (data: any) => {
        console.log('Verification History Details Data:', data);
        this.patchFormValues(data);
      },
      error: (error: any) => {
        console.log(error);
      },
    });
  }

  private initForm(): void {
    this.verificationForm = this.fb.group({
      companyName: [''],
      companyType: [''],
      contactName: [''],
      contactNos: [''],
      country: [''],
      website: [''],
      email: [''],
      registeredAddress: [''],
      requestStatus: [''],
      riskRating: [''],
      assessmentComments: [''],
      queuedForAudit: [''],
    });
  }

  private patchFormValues(data: any): void {
    const request = data?.verificationRequest || {};
    const targetRequestId = request.id || data?.id || this.requestId;

    this.verificationForm.patchValue({
      companyName: request.companyName || data?.companyName || '',
      companyType: data?.companyType || request.companyType || '',
      contactName: request.contactName || '',
      contactNos: request.contactNos || '',
      country: request.country || data?.country || '',
      website: request.website || '',
      email: request.email || '',
      registeredAddress: request.registeredAddress || data?.registeredAddress || '',
      requestStatus: request.requestStatus || '',
      riskRating: data?.riskRating || '',
      assessmentComments: data?.assessmentComments || '',
      queuedForAudit: request.queuedForAudit !== undefined ? (request.queuedForAudit ? 'True' : 'False') : (data?.queuedForAudit !== undefined ? (data.queuedForAudit ? 'True' : 'False') : '')
    });
    this.verificationForm.disable();

    if (targetRequestId) {
      this.getUploadedDocuments(targetRequestId);
    }
  }

  getUploadedDocuments(id: string) {
    this.userService.getMediaFiles('VERIFICATION', id).subscribe({
      next: (data: any) => {
        this.uploadedFiles = data || [];
      },
      error: (error: any) => {
        console.log(error);
      },
    });
  }

  viewMediaFile(row: any) {
    this.matDialog.open(ViewUploadedFile, {
      disableClose: true,
      height: '800px',
      width: '800px',
      data: row,
    });
  }

  onBack(): void {
    this.location.back();
  }
}
